<template>
  <div class="home">
    <!-- nav -->
    <div class="nav_wapper">
      <div class="nav">
        <ul class="nav_connect">
          <li>
            <a href="javascript:scrollTo(0, 0)">首页</a>
          </li>
          <li>
            <a href="#aboutOur">关于我们</a>
          </li>
          <li>
            <a href="#Contact">联系我们</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="Swiper">
      <Swiper />
    </div>
    <!-- 中部文字 -->
    <div class="text_connect">
      <div class="text_connect_wapper">
        <div class="top_text">专业行业软件系统研发</div>
        <div class="top_english">
          Professional industry software system development
        </div>
        <div class="center_text">
          致力于为您提供专业的软件服务
          为品牌和商家提供从流量到变现的一站式解决方案
        </div>
        <div class="button">
          <a href="#Contact">
            <span>点击咨询</span>
          </a>
        </div>
      </div>
    </div>
    <!-- 轮播图下方tip -->
    <div class="swiper_tip">
      <div class="swiper_tip_wapper">
        <div class="tip_item">
          <div class="tip_item_wapper">
            <img src="@/assets/image/tip1.webp" alt />
            <div class="item_fenge">
              <div class="item_title">全方位保障</div>
              <div class="item_connect">打造一款透明可信的软件</div>
            </div>
          </div>
        </div>
        <div class="tip_item">
          <div class="tip_item_wapper">
            <img src="@/assets/image/tip2.webp" alt />
            <div class="item_fenge">
              <div class="item_title">全方位保障</div>
              <div class="item_connect">打造一款透明可信的软件</div>
            </div>
          </div>
        </div>
        <div class="tip_item">
          <div class="tip_item_wapper">
            <img src="@/assets/image/tip3.webp" alt />
            <div class="item_nofenge">
              <div class="item_title">全方位保障</div>
              <div class="item_connect">打造一款透明可信的软件</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="peculiarity_tip">
      <div class="peculiarity_tip_wapper">
        <div class="peculiarity_tip_item">
          <img src="@/assets/image/peculiarity1.webp" alt />
        </div>
        <div class="peculiarity_tip_item">
          <img src="@/assets/image/peculiarity2.webp" alt />
        </div>
        <div class="peculiarity_tip_item">
          <img src="@/assets/image/peculiarity3.webp" alt />
        </div>
      </div>
    </div>
    <div class="notice">
      <span @click="visible = true"
        >关于【ftrip】微信功能运营主体变更及隐私政策更新的公告</span
      >
    </div>
    <div class="ourAdvantage">
      <div class="ourAdvantage_wapper">
        <div class="advantage_item"></div>
        <div class="advantage_item">
          <img src="@/assets/image/advantage.webp" alt />
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div id="aboutOur">
      <div class="aboutOur_wapper">
        <div class="aboutOur_item">
          <img src="@/assets/image/about.webp" alt />
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div id="Contact">
      <div class="Contact_wapper">
        <div class="Contact_item">
          <img src="@/assets/image/contact.webp" alt />
        </div>
      </div>
    </div>
  </div>
  <!-- 公司信息 -->
  <div class="company_info">
    <span>Copyright©2024 成都百弦科技有限公司</span>
    <a
      style="padding-left: 40px"
      href="https://beian.miit.gov.cn"
      target="_blank"
      >备案号：蜀ICP备2024096152号-1</a
    >
    <span style="padding-left: 40px">投诉邮箱：dalin1@baixian-inc.com</span>
  </div>
  <Dialog v-if="visible" @closeDialog="closeDialog" />
</template>

<script>
// @ is an alias to /src
import Swiper from "@/components/Head/Swiper.vue";
import Dialog from "@/components/Dialog/index.vue";
export default {
  name: "HomeView",
  data() {
    return {
      visible: true,
    };
  },
  components: {
    Swiper,
    Dialog,
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="less">
.home {
  margin: 0 auto;
  position: relative;
}
.swiper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.nav_wapper {
  position: absolute;
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  justify-content: end;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  padding: 1.25rem;
}
.nav {
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.625rem;
  box-sizing: border-box;
  .nav_connect {
    // height: 2.8125rem;
    width: 100%;
    display: flex;
    justify-content: end;
  }
  .nav_connect ul {
    // margin: 0 0 0 1.875rem;
    padding: 0;
    font-size: 1.125rem;
    line-height: 1.875rem;
    whitewhite-space: nowrap;
  }
  .nav_connect li {
    list-style-type: none;
    display: inline;
  }
  .nav_connect li a {
    color: #fff;
    border-radius: 0.25rem;
    border: 1px solid rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(7.5px);
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    text-decoration: none;
    font-family: "PingFang SC";
    padding: 1.25rem 2.25rem;
    margin: 0 1.875rem 0 1.875rem;
  }
  .nav_connect li a:hover {
    color: #3a82ff;
    background-color: rgba(255, 255, 255, 0.5);
    border: 1px solid #fff;
  }
}
.text_connect {
  position: absolute;
  top: 14.125rem;
  left: 28.625rem;
  z-index: 3;
  .text_connect_wapper {
    display: flex;
    justify-items: center;
    align-content: center;
    flex-direction: column;
  }
  .top_text {
    color: #fff;
    font-family: "Source Han Sans SC";
    font-size: 6rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .top_english {
    font-family: Inter;
    font-size: 2.25rem;
    font-style: normal;
    font-weight: 800;
    background: linear-gradient(
      180deg,
      #fff 31.7%,
      rgba(255, 255, 255, 0) 79.55%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .center_text {
    margin-top: 4.25rem;
    color: var(--color-base-white, #fff);
    text-align: center;
    font-family: "PingFang SC";
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.075rem;
  }
  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4rem;

    span {
      padding: 1.5rem 2.9375rem;
      justify-content: center;
      align-items: center;
      gap: 0.25rem;
      border-radius: 0.5rem;
      border: 1px solid var(--color-base-white, #fff);
      background: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(7.5px);
    }
    a {
      text-decoration: none;
      outline: none;
      color: #ffffff;
    }
    a:hover {
      color: #3a82ff;
    }
    span:hover {
      background: rgba(0, 0, 0, 0.4);
    }
  }
}
.swiper_tip {
  position: absolute;
  top: 52.25rem;
  left: 7.94rem;
  z-index: 3;
  border-radius: 2rem;
  background: url("../assets/image/tip_background.webp") no-repeat center center;
  background-size: 100% 120%;
  box-shadow: 0px 1px 6px 0px rgba(1, 20, 51, 0.15);
  width: 104.0625rem;
  height: 19.325rem;
  flex-shrink: 0;

  .swiper_tip_wapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104.0625rem;

    padding: 6rem 4.3125rem 7.25rem 0.3125rem;
    .tip_item {
      .tip_item_wapper {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-left: 4rem;
          width: 8rem;
          height: 8rem;
        }
        .item_fenge {
          border-right: 0.0625rem solid #666;
          padding-right: 5.0625rem;
        }
        .item_nofenge {
          padding-right: 5.0625rem;
        }
        .item_title {
          color: #333;
          font-family: "Source Han Sans SC";
          font-size: 2rem;
          letter-spacing: 0.1rem;
          margin-bottom: 0.5rem;
        }
        .item_connect {
          color: #666;
          font-family: "Source Han Sans SC";
          font-size: 1.25rem;
          letter-spacing: 0.075rem;
        }
      }
    }
  }
}
.peculiarity_tip {
  position: absolute;
  top: 80.25rem;
  left: 1.455rem;
  z-index: 4;
  .peculiarity_tip_wapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .peculiarity_tip_item {
      border: radius 1rem;
      width: 34.375rem;
      height: 40rem;
      margin: 0 2.3125rem 0 2.3125rem;
      img {
        width: 34.375rem;
        height: 40rem;
      }
    }
  }
}
.notice {
  position: absolute;
  top: 77.25rem;
  left: 4rem;
  z-index: 4;
  span {
    cursor: pointer;
    color: #3a82ff;
  }
}

.ourAdvantage {
  display: flex;
  justify-content: center;
  align-items: center;
  .advantage_item {
    width: 106.25rem;
    height: 61.5625rem;
    img {
      width: 106.25rem;
      height: 60.5625rem;
    }
  }
}
#aboutOur {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6.25rem;
  img {
    width: 108.125rem;
    height: 59.5625rem;
  }
}
#Contact {
  display: flex;
  justify-content: center;
  align-items: center;

  .Contact_item {
    img {
      width: 100%;
      height: 28.4375rem;
    }
  }
}
.company_info {
  margin-top: 20px;
  height: 200px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 0 40px;
  color: #333;
}
a {
  text-decoration: none;
  color: #333;
}
</style>
